<script setup lang="ts">
import { DisclosureButton } from '@headlessui/vue'

defineProps<{
    open: boolean
    level: Dimension
    as?: string
}>()

/**
 * Use the query params.
 */
const { config } = useParams()

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <dt class="bg-neutral p-4 text-lg">
        <component
            :is="as || DisclosureButton"
            class="flex w-full flex-col gap-4 text-left"
        >
            <div class="flex w-full items-center gap-2">
                <div v-if="level.hasChildren" class="flex items-center">
                    <ChevronDownIcon
                        :class="[
                            open ? '-rotate-180' : 'rotate-0',
                            'h-4 transform transition-transform duration-200 ease-in-out'
                        ]"
                        aria-hidden="true"
                    />
                </div>

                <h1 class="flex-1 text-xs font-bold uppercase">
                    {{ level.name }}
                </h1>

                <div class="ml-4 flex items-center">
                    <UiButton
                        small
                        transparent
                        @click.stop="config.dimension = level.id"
                    >
                        {{ t('show-data') }}
                    </UiButton>
                </div>
            </div>

            <p v-if="level.description" class="whitespace-pre-wrap text-sm">
                {{ level.description }}
            </p>
        </component>
    </dt>
</template>